import type { ReactNode } from 'react';

import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export interface BackLinkSubheaderProps {
  /** Route to navigate to when the back link is clicked */
  to: string;
  /** Link label (e.g. "Back to all templates", "Dashboard") */
  children: ReactNode;
  /** Optional content to render on the right side of the bar (e.g. action buttons) */
  rightContent?: ReactNode;
  /** Optional click handler (e.g. for tracking or resetting state) */
  onClick?: () => void;
}

/**
 * Reusable subheader bar with a back link (chevron + label).
 * Matches the claims page style: vai-px-6 vai-py-3, white background, bottom border.
 * Root uses flexShrink: 0 so the flex parent cannot shrink it; then vai-h-10 / padding apply.
 */
export const BackLinkSubheader = ({
  to,
  children,
  rightContent,
  onClick,
}: BackLinkSubheaderProps) => {
  return (
    <div
      className="vai-flex vai-min-h-[65px] vai-px-6 vai-py-3 vai-bg-white vai-border-b vai-border-gray-200 vai-text-primary vai-justify-between vai-items-center"
      style={{ flexShrink: 0 }}
    >
      <Link
        to={to}
        onClick={onClick}
        className="vai-inline-flex vai-items-center vai-text-primary"
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          className="vai-mr-2 vai-text-primary"
        />
        {children}
      </Link>
      {rightContent != null ? (
        <div className="vai-flex vai-gap-2 vai-items-center">
          {rightContent}
        </div>
      ) : null}
    </div>
  );
};
